import React, { useEffect } from "react";
import { connect } from "react-redux";
import { number, string, object, func } from "prop-types";
import get from "lodash/get";
import { WithLazy } from "@quintype/components";

import FitColorLogo from "../../atoms/icons/fit-color-logo";
import FitHindi from "../../atoms/icons/fit-hindi";
import Headline from "../../atoms/headline";
import CustomStoryCard7 from "../../molecules/custom-story-card7";
import { getStoryPageWruData, wruUserEvent } from "../../helper/api";
import { setWruFitData } from "../../helper/actions";
import { readCookie } from "../../helper/cookies";
import { sections } from "../../utils/utils";
import translate from "../../translate";

import "./more-from-fit.m.css";

const MoreFromFitBase = ({ storyId, publisherName, merchantId, fitData, setWruFitData }) => {
  useEffect(() => {
    if (!fitData[storyId]) {
      const type = publisherName === "quint" ? "fqmore" : "hfqmore";
      const thinmint = readCookie("thinmint");
      getStoryPageWruData(storyId, thinmint, merchantId, type).then((data) => {
        const recommendations = get(data, ["0", "recommendations"], []);
        setWruFitData(recommendations, storyId);
      });
    }
  }, []);

  const handleUserClick = (item) => () => {
    const body = {
      uid: readCookie("thinmint"),
      Cid: item.Cid, // article id
      eid: "EVENT1",
      merchantId: `${merchantId}`,
      ip: "",
      timestamp: `${new Date().getTime()}`,
      eventType: "RECOMMENDATION_VIEW_EVENT",
      recommendation: "wru",
      ref: "Fit Stories widget", // the heading of the recommendation widget
      userAgent: window.navigator.userAgent,
    };
    wruUserEvent(merchantId, body).then((i) => console.log("Wru click event", i));
  };

  const list = fitData[storyId] || [];

  if (!list.length) return null;

  const items = list.map((ele) => ({
    headline: ele.Description,
    url: `https://fit.thequint.com/${ele.Slug}`,
    "hero-image-s3-key": ele.ImageUrl,
    "hero-image-metadata": ele.ImageMetaData,
  }));

  return (
    <div styleName="wrapper">
      <div styleName="more-from-fit">
        <Headline text={translate(publisherName, "more_from_fit")} headerType={8} useAlternateHeadline />
        {publisherName === "quint-hindi" ? <FitHindi /> : <FitColorLogo width={65} height={37} />}
      </div>
      <div styleName="stories">
        {items.slice(0, 2).map((item, index) => (
          <div key={index} onClick={handleUserClick(item)}>
            <CustomStoryCard7 story={item} useAlternateHeadline isExternalStory rel="nofollow" />
          </div>
        ))}
      </div>
    </div>
  );
};

MoreFromFitBase.propTypes = {
  merchantId: number,
  fitData: object,
  storyId: string,
  publisherName: string,
  setWruFitData: func,
};

const mapStateToProps = (state) => {
  return {
    merchantId: get(state, ["qt", "config", "publisher-attributes", "fit_wru_id"]),
    publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
    fitData: get(state, ["storyReducer", "fitData"], []),
  };
};

const mapDispatchToProps = (dispatch) => ({
  setWruFitData: (data, storyId) => dispatch(setWruFitData(data, storyId)),
});

const MoreFromFitWrapper = connect(mapStateToProps, mapDispatchToProps)(MoreFromFitBase);

const MoreFromFit = ({ story, publisherName }) => {
  let filterItems = [];
  let enableWidget = false;

  if (publisherName === "quint") {
    filterItems = sections({ type: "story" }, story);
    enableWidget = filterItems.includes("Coronavirus");
  } else if (publisherName === "quint-hindi") {
    const tags = get(story, ["tags"], []);
    filterItems = tags.map((tag) => tag.name).join(",");
    enableWidget = filterItems.includes("कोरोनावायरस");
  }

  if (publisherName === "fit" || !enableWidget) return null;

  return <WithLazy margin="300px">{() => <MoreFromFitWrapper storyId={story.id} />}</WithLazy>;
};

MoreFromFit.propTypes = {
  story: object,
  publisherName: string,
};

export default MoreFromFit;
